import axios from "axios";

const baseURL = import.meta.env.VITE_API_URL;

const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor for response handling
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // Global error handling can be added here
    console.error("API Error:", error);
    return Promise.reject(error);
  }
);

export default api;
